import {environment} from '../../../config/environments/environment';
import {ProvideKeycloakOptions} from 'keycloak-angular';

export const UK_URL_PATTERN = 'fordfnp.co.uk';
export const DEFAULT_MIN_TOKEN_VALIDITY: number = 20;
export const DEFAULT_API_MATCH_REGEX = /^(?:http?:\/\/)|(?:https?:\/\/)?(?:[^.]+\.)?((azurewebsites)|(localhost)|(oeconnection))((\.net)|(\.com)|(:8080))(\/.*)?$/;
export const DEFAULT_API_MATCH_METHODS = ['GET', 'POST', ' PATCH', 'PUT', 'DELETE'];
export const DEFAULT_KEYCLOAK_INIT_CONFIG: ProvideKeycloakOptions = {
    config: {
        url: environment.keycloak.url,
        realm: environment.keycloak.realm,
        clientId: environment.keycloak.clientId
    },
    initOptions: {
        onLoad: 'check-sso',
        checkLoginIframe: false,
        locale: (() => window.location.origin.includes(UK_URL_PATTERN) ? 'en' : 'de')(),
        pkceMethod: 'S256'
    }
};